<template>
  <div v-if="!sended" class="container tim-survey mx-auto lg:p-20 p-4">
    <span v-if="errors" class="text-red-600 text-center">{{ errors }}</span>
    <h1 class="text-center text-[#01508c] text-3xl pb-8">
      A TIM quer saber sua opinião!
    </h1>
    <div class="solved flex flex-col items-center">
      <label class="text-[#01508c] text-xl pb-2"
        >Sua necessidade foi resolvida?</label
      >
      <div class="solved-group flex w-full">
        <button
          :class="solved == true ? 'selected' : ''"
          @click="solved = true"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2h144c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48h-97.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7M32 192h64c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32"
            />
          </svg>
          Sim
        </button>
        <button
          :class="solved == false ? 'selected' : ''"
          @click="solved = false"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 512 512"
          >
            <path
              fill="currentColor"
              d="M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2h144c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48h-97.5c-19 0-37.5 5.6-53.3 16.1l-38.5 25.7C176 91.6 160 121.6 160 153.7v111.2c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7M32 384h64c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32"
            />
          </svg>
          Não
        </button>
      </div>
    </div>
    <div class="rating flex flex-col items-center">
      <label class="text-[#01508c] text-xl">Avalie esse atendimento?</label>
      <div class="rating-group flex w-full justify-center">
        <div
          v-for="number in 5"
          :key="number"
          v-on:mouseover="hover = number"
          v-on:mouseleave="hover = null"
          @click="rating = number"
          :class="hover >= number || rating >= number ? 'star filled' : 'star'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="m7.325 18.923l1.24-5.313l-4.123-3.572l5.431-.47L12 4.557l2.127 5.01l5.43.47l-4.123 3.572l1.241 5.313L12 16.102z"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="recommendation flex flex-col items-center">
      <label class="text-[#01508c] text-xl text-center pb-2"
        >Qual a probabilidade de você recomendar este serviço para um
        colega?</label
      >
      <div class="recommendation-group flex w-full">
        <button
          v-for="(number, i) in 11"
          :key="i"
          :class="recommendation == i ? 'selected' : ''"
          @click="recommendation = i"
        >
          {{ i }}
        </button>
      </div>
    </div>

    <div class="comments">
      <textarea
        v-model="comments"
        aria-placeholder="Deixe seu comentário"
        placeholder="Deixe seu comentário"
        rows="4"
      ></textarea>
    </div>

    <div class="submit">
      <button :disabled="!isValid()" @click="submit">
        <svg
          v-if="loading"
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M12 2A10 10 0 1 0 22 12A10 10 0 0 0 12 2Zm0 18a8 8 0 1 1 8-8A8 8 0 0 1 12 20Z"
            opacity="0.5"
          />
          <path
            fill="currentColor"
            d="M20 12h2A10 10 0 0 0 12 2V4A8 8 0 0 1 20 12Z"
          >
            <animateTransform
              attributeName="transform"
              dur="1s"
              from="0 12 12"
              repeatCount="indefinite"
              to="360 12 12"
              type="rotate"
            />
          </path>
        </svg>
        <span v-else>Avaliar</span>
      </button>
    </div>
  </div>
  <div v-else class="container mx-auto lg:p-20 p-4">
    <h1 class="text-center text-[#01508c] text-3xl pb-8">
      Obrigado por avaliar o atendimento!
    </h1>
  </div>
</template>

<script>
export default {
  name: "SurveyView",
  data() {
    return {
      solved: null,
      recommendation: null,
      hover: null,
      rating: null,
      comments: null,
      loading: false,
      sended: false,
      session: null,
      errors: null,
    };
  },
  mounted() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.session = urlParams.get("session");
  },
  methods: {
    isValid() {
      return this.solved != null || this.recommendation != null || this.rating;
    },
    async submit() {
      this.loading = true;
      this.errors = null;

      let url = process.env.VUE_APP_ROOT_API + "survey";
      await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sessionId: this.session,
          survey: JSON.stringify({
            solved: this.solved,
            recommendation: this.recommendation,
            rating: this.rating,
            comments: this.comments,
          }),
          when: Date.now() / 1000,
        }),
        mode: "cors",
      })
        .then((response) => {
          if (response.status == 200) {
            this.sended = true;
          } else {
            this.errors =
              "Não foi possível enviar o formulário. Tente novamente mais tarde";
          }
        })
        .finally(() => {
          this.loading = false;
        });

      await fetch(process.env.VUE_APP_ROOT_LIGO_BOTERIA + this.session, {
        method: "POST",
      });
    },
  },
};
</script>
